import { get, post, put, del } from '../apiClient';
import { API_ENDPOINTS } from '../config';

const userService = {
  // Update user profile settings
  updateProfile: async (profileData) => {
    try {
      const response = await put(API_ENDPOINTS.USER.UPDATE_PROFILE, profileData);
      
      if (response.responseCode === 200) {
        return {
          success: true,
          user: response.data.user,
          message: response.responseMessage || 'Profile updated successfully'
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to update profile'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to update profile'
      };
    }
  },

  // Get current user profile
  getProfile: async () => {
    try {
      const response = await get(API_ENDPOINTS.USER.PROFILE);
      
      if (response.responseCode === 200) {
        return {
          success: true,
          user: response.data.user
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to get profile'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to get profile'
      };
    }
  },

  // Change password
  changePassword: async (passwordData) => {
    try {
      const response = await put(API_ENDPOINTS.USER.CHANGE_PASSWORD, passwordData);
      
      if (response.responseCode === 200) {
        return {
          success: true,
          message: response.responseMessage || 'Password changed successfully'
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to change password'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to change password'
      };
    }
  }
};

export default userService;
